"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleProvider = exports.LOCALE_ID = exports.LOCALE_EN = void 0;
const React = require("react");
const react_intl_1 = require("react-intl");
const intlEN = require("react-intl/locale-data/en");
const intlID = require("react-intl/locale-data/id");
// OPTIONAL polyfill (remove these 3 lines if you drop 'intl')
const IntlPolyfill = require("intl");
require("intl/locale-data/jsonp/en");
require("intl/locale-data/jsonp/id");
exports.LOCALE_EN = 'en';
exports.LOCALE_ID = 'id';
const haveAllIntlLocales = (locales) => {
    const fns = [Intl.NumberFormat, Intl.DateTimeFormat];
    return fns.every(fn => fn.supportedLocalesOf(locales).length === locales.length);
};
if (global.Intl) {
    if (!haveAllIntlLocales([exports.LOCALE_EN, exports.LOCALE_ID])) {
        // remove this block entirely if you drop 'intl'
        Intl.NumberFormat = IntlPolyfill.NumberFormat;
        Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
    }
}
else {
    // remove if you drop 'intl'
    global.Intl = IntlPolyfill;
}
class LocaleProvider extends React.Component {
    constructor(props) {
        super(props);
        (0, react_intl_1.addLocaleData)(intlEN);
        (0, react_intl_1.addLocaleData)(intlID);
    }
    render() {
        const { children, locale = exports.LOCALE_ID, messages } = this.props;
        return (React.createElement(react_intl_1.IntlProvider, { locale: locale, messages: messages[locale] }, children));
    }
}
exports.LocaleProvider = LocaleProvider;
//# sourceMappingURL=LocaleProvider.js.map